const UserActionTypes = {

  CHANGE_EMAIL_START: 'CHANGE_EMAIL_START',
  CHANGE_EMAIL_SUCCESS: 'CHANGE_EMAIL_SUCCESS',
  CHANGE_EMAIL_FAILURE: 'CHANGE_EMAIL_FAILURE',

  CHECK_EMAIL_START: 'CHECK_EMAIL_START',
  CHECK_EMAIL_SUCCESS: 'CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE: 'CHECK_EMAIL_FAILURE',

  CONFIRM_PASSWORD_START: 'CONFIRM_PASSWORD_START',
  CONFIRM_PASSWORD_SUCCESS: 'CONFIRM_PASSWORD_SUCCESS',
  CONFIRM_PASSWORD_FAILURE: 'CONFIRM_PASSWORD_FAILURE',

  CHANGE_PASSWORD_START: 'CHANGE_PASSWORD_START',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',

  SIGN_IN_START: 'SIGN_IN_START',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',

  SIGN_OUT_START: 'SIGN_OUT_START',
  SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
  SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',

  SIGN_UP_START: 'SIGN_UP_START',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_UP_FAILURE: 'SIGN_UP_FAILURE',

  COMFIRM_START: 'COMFIRM_START',
  COMFIRM_SUCCESS: 'COMFIRM_SUCCESS',
  COMFIRM_FAILURE: 'COMFIRM_FAILURE',

  SIGN_IN_SOCIAL_START: 'SIGN_IN_SOCIAL_START',
  SIGN_IN_SOCIAL_SUCCESS: 'SIGN_IN_SOCIAL_SUCCESS',
  SIGN_IN_SOCIAL_FAILURE: 'SIGN_IN_SOCIAL_FAILURE',

  PROFILE_SET_START: 'PROFILE_SET_START',
  PROFILE_SET_SUCCESS: 'PROFILE_SET_SUCCESS',
  PROFILE_SET_FAILURE: 'PROFILE_SET_FAILURE'
};

export default UserActionTypes;
